import { FullScreenLoading } from '@backrs_ui/common-ui';

import { useGetCurrentSubscriptionQuery } from '@backrs_ui/grow-ui/src/redux/subscription/subscriptionApi';

import { SubscriptionPage } from './components/SubscriptionPage';

export type PaymentPageProps = Readonly<{
  onPaymentSuccess?: (sessionId?: string) => void;
  onBasicPlanContinue?: () => void;
  subscriptionView?: 'PAYWALL' | 'ONBOARDING';
  onCheckoutViewChange?: (isShowingCheckout: boolean) => void;
}>;

export const SubscriptionPageContainer = ({
  onPaymentSuccess,
  onBasicPlanContinue,
  subscriptionView = 'PAYWALL',
  onCheckoutViewChange,
}: PaymentPageProps) => {
  const { data: subscription, isLoading, refetch } = useGetCurrentSubscriptionQuery(undefined);

  if (isLoading) {
    return <FullScreenLoading />;
  }

  return (
    <SubscriptionPage
      subscription={subscription}
      onPaymentSuccess={onPaymentSuccess}
      onBasicPlanContinue={onBasicPlanContinue}
      subscriptionView={subscriptionView}
      refetchSubscription={refetch}
      onCheckoutViewChange={onCheckoutViewChange}
    />
  );
};
